import script from "./SettingDefForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingDefForm.vue?vue&type=script&setup=true&lang=js"

import "./SettingDefForm.vue?vue&type=style&index=0&id=30ed6a35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ed6a35"]])

export default __exports__